import React from 'react';

const Footer = () => {

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © 2025 XGono Tubing Adventure. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
